export default {"src":"/_next/static/media/channel-finance-home.f0755cd3.svg","height":37,"width":37};